import { ui } from "@/components/ui";

const TableSkeleton = () => {
	return (
		<div className="space-y-2 w-full h-full">
			<div className="flex md:flex-row flex-col justify-between gap-2 my-2">
				<div className="flex items-center gap-x-2 w-fit">
					<ui.Skeleton className="w-60 h-12" />
					<ui.Skeleton className="rounded-full w-12 h-12" />
				</div>
				<ui.Skeleton className="w-32 h-12" />
			</div>
			<ui.Skeleton className="w-full h-[calc(100vh-200px)]" />
		</div>
	);
};

export default TableSkeleton;
